import { useState } from "react";
import { ChevronDown, Moon, Sun, LogOut, User, Menu } from "lucide-react";

export function Header({ darkMode, onToggleDark, onMenuClick }) {
  const [profileOpen, setProfileOpen] = useState(false);

  const admin_data = JSON.parse(localStorage.getItem("admin_data") || "{}");
  const adminName = admin_data?.admin_name || "Admin User";
  const adminEmail = admin_data?.admin_email || "admin@example.com";
  const avatarLetter = adminName.charAt(0).toUpperCase();

  const handleLogout = () => {
    if (!window.confirm("Are you sure you want to sign out?")) return;
    localStorage.removeItem("admin_data");
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <header
      className="h-14 flex items-center justify-between border-b px-4 md:px-5 flex-shrink-0 z-10 gap-3"
      style={{
        background: "hsl(var(--header-background))",
        borderColor: "hsl(var(--header-border))",
      }}
    >
      {/* Left — hamburger (mobile only) */}
      <div className="flex items-center gap-3 flex-1">
        <button
          onClick={onMenuClick}
          className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg border border-border text-muted-foreground hover:bg-muted transition-colors flex-shrink-0"
          aria-label="Open menu"
        >
          <Menu className="w-4 h-4" />
        </button>
      </div>

      {/* Right */}
      <div className="flex items-center gap-2">
        {/* Dark mode toggle */}
        <button
          onClick={onToggleDark}
          className="w-9 h-9 flex items-center justify-center rounded-lg border border-border text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          aria-label="Toggle dark mode"
        >
          {darkMode ? (
            <Sun className="w-4 h-4" />
          ) : (
            <Moon className="w-4 h-4" />
          )}
        </button>

        {/* Profile dropdown */}
        <div className="relative">
          <button
            onClick={() => setProfileOpen((o) => !o)}
            className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-muted transition-colors"
          >
            <div
              className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
              style={{ background: "var(--gradient-accent)" }}
            >
              {avatarLetter}
            </div>
            <div className="hidden md:block text-left">
              <p className="text-xs font-semibold text-foreground leading-tight">
                {adminName}
              </p>
              <p className="text-[10px] text-muted-foreground">{adminEmail}</p>
            </div>
            <ChevronDown className="hidden md:block w-3.5 h-3.5 text-muted-foreground" />
          </button>

          {profileOpen && (
            <>
              {/* Click-outside overlay */}
              <div
                className="fixed inset-0 z-40"
                onClick={() => setProfileOpen(false)}
              />
              <div
                className="absolute right-0 top-11 w-52 rounded-xl border border-border bg-card shadow-lg z-50 overflow-hidden"
                style={{ boxShadow: "var(--shadow-lg)" }}
              >
                <div className="px-4 py-3 border-b border-border">
                  <p className="text-sm font-semibold text-foreground">
                    {adminName}
                  </p>
                  <p className="text-xs text-muted-foreground">{adminEmail}</p>
                  <span
                    className="mt-1.5 inline-block text-[10px] font-bold px-2 py-0.5 rounded-full"
                    style={{
                      background: "hsl(var(--accent-muted))",
                      color: "hsl(var(--accent))",
                    }}
                  >
                    Administrator
                  </span>
                </div>
                <div className="py-1">
                  <a
                    href="/profile-settings"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground hover:bg-muted transition-colors"
                  >
                    <User className="w-4 h-4 text-muted-foreground" />
                    Profile Settings
                  </a>
                </div>
                <div className="border-t border-border py-1">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-red-500 hover:bg-muted transition-colors text-left"
                  >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
